import React, { useState, useEffect } from "react";
import TopNavigation from "../../../components/TopNavigation";
import NoQuiz from "../../QuizPage/NoQuiz";
import ListQuestion from "../ListQuestion";
import moment from "moment";
import * as Assets from "../../../utils/svg_assets";
import * as PageRoutes from "../../../utils/route_pages";
import { connect } from "react-redux";
import { Base } from "../../../components/RootLayout";
import { useParams } from "react-router-dom";
import "./style.scss";

const StartQuestion = (props) => {
  const params = useParams();
  const { getSurveyDetail } = props;
  const [surveyDetail, setSurveyDetail] = useState({});
  const [result, setResult] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [isValidateModal, setIsValidateModal] = useState(false);

  const getData = async () => {
    const { data, status } = await getSurveyDetail(params.surveyId);
    if (status == 200) {
      setSurveyDetail(data);
    } else {
      setSurveyDetail({});
    }
  };

  useEffect(() => {
    getData();
  }, []);

  props = {
    ...props,
    result,
    setResult,
    isModal,
    setIsModal,
    isValidateModal,
    setIsValidateModal,
    data: surveyDetail.questions,
  };

  return (
    <Base>
      <TopNavigation
        titlePage="Survey"
        toPath={-1}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="survey-start-content">
        {surveyDetail.id ? (
          <>
            <div className="content-header">
              <span className="survey-about">
                Survey about{" "}
                <strong>
                  <span className="bold">
                    {surveyDetail.read_topics[0].name}
                  </span>
                </strong>
              </span>
              <div className="title-wrapper">
                <span className="survey-title">{surveyDetail.name}</span>
              </div>
              <span className="survey-creator">
                Posted by {surveyDetail.creator},{" "}
                {moment(surveyDetail.start).format("DD MMM YYYY")}
              </span>
              <div className="survey-point">
                <img src={Assets.iconGoldCoin} alt="logo_image" />
                <div className="point-wrapper">
                  <span className="point">
                    Get {surveyDetail.points} {surveyDetail.currency.name}
                  </span>
                </div>
              </div>
            </div>
            <hr />
            <div className="content-body">
              <ListQuestion {...props} />
            </div>
          </>
        ) : (
          <NoQuiz title="survey" />
        )}
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  surveyDetail: state.SurveySM.surveyDetail,
});

const mapDispatchToProps = (dispatch) => ({
  getSurveyDetail: dispatch.SurveySM.getSurveyDetail,
});

export default connect(mapStateToProps, mapDispatchToProps)(StartQuestion);
